/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgentType } from './AgentType';
import {
    AgentTypeFromJSON,
    AgentTypeFromJSONTyped,
    AgentTypeToJSON,
} from './AgentType';
import type { CoveringAgentId } from './CoveringAgentId';
import {
    CoveringAgentIdFromJSON,
    CoveringAgentIdFromJSONTyped,
    CoveringAgentIdToJSON,
} from './CoveringAgentId';
import type { DocumentVersionUploadAgent } from './DocumentVersionUploadAgent';
import {
    DocumentVersionUploadAgentFromJSON,
    DocumentVersionUploadAgentFromJSONTyped,
    DocumentVersionUploadAgentToJSON,
} from './DocumentVersionUploadAgent';
import type { HumanToken } from './HumanToken';
import {
    HumanTokenFromJSON,
    HumanTokenFromJSONTyped,
    HumanTokenToJSON,
} from './HumanToken';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface OfferLcep
 */
export interface OfferLcep {
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    id: any | null;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    firstName: any | null;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    lastName: any | null;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    email: any | null;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    roles: any | null;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    rbacRoles?: any | null;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    oxUsersId: any | null;
    /**
     * 
     * @type {HumanToken}
     * @memberof OfferLcep
     */
    humanToken?: HumanToken;
    /**
     * 
     * @type {DocumentVersionUploadAgent}
     * @memberof OfferLcep
     */
    agent?: DocumentVersionUploadAgent;
    /**
     * 
     * @type {CoveringAgentId}
     * @memberof OfferLcep
     */
    coveringAgentId?: CoveringAgentId;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    title?: any | null;
    /**
     * 
     * @type {AgentType}
     * @memberof OfferLcep
     */
    agentType?: AgentType;
    /**
     * 
     * @type {any}
     * @memberof OfferLcep
     */
    licenses?: any | null;
}

/**
 * Check if a given object implements the OfferLcep interface.
 */
export function instanceOfOfferLcep(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "roles" in value;
    isInstance = isInstance && "oxUsersId" in value;

    return isInstance;
}

export function OfferLcepFromJSON(json: any): OfferLcep {
    return OfferLcepFromJSONTyped(json, false);
}

export function OfferLcepFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferLcep {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'roles': json['roles'],
        'rbacRoles': !exists(json, 'rbac_roles') ? undefined : json['rbac_roles'],
        'oxUsersId': json['ox_users_id'],
        'humanToken': !exists(json, 'human_token') ? undefined : HumanTokenFromJSON(json['human_token']),
        'agent': !exists(json, 'agent') ? undefined : DocumentVersionUploadAgentFromJSON(json['agent']),
        'coveringAgentId': !exists(json, 'covering_agent_id') ? undefined : CoveringAgentIdFromJSON(json['covering_agent_id']),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'agentType': !exists(json, 'agent_type') ? undefined : AgentTypeFromJSON(json['agent_type']),
        'licenses': !exists(json, 'licenses') ? undefined : json['licenses'],
    };
}

export function OfferLcepToJSON(value?: OfferLcep | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'email': value.email,
        'roles': value.roles,
        'rbac_roles': value.rbacRoles,
        'ox_users_id': value.oxUsersId,
        'human_token': HumanTokenToJSON(value.humanToken),
        'agent': DocumentVersionUploadAgentToJSON(value.agent),
        'covering_agent_id': CoveringAgentIdToJSON(value.coveringAgentId),
        'title': value.title,
        'agent_type': AgentTypeToJSON(value.agentType),
        'licenses': value.licenses,
    };
}

